<template>
    <div>
        <section class="mb-5" v-if="productId > 0">
            <div class="container mt-5">
                <div class="card">
                    <div class="row">
                        <aside class="col-sm-5">
                            <article class="gallery-wrap">
                                <div class="img-big-wrap">
                                    <div> 
                                        <a href="javascript:void(0)">
                                            <img :src="appUrl+'/'+mainImage" 
                                                :alt="product.title" 
                                                class="img-fluid">
                                        </a>
                                    </div>
                                </div>
                                <div class="img-small-wrap" v-if="product.images.length > 1">
                                    <div class="item-gallery" v-for="(image, key, index) in product.images"> 
                                        <a href="javascript:void(0)"
                                            @click="updateMainImage(image.image_path)">
                                            <img :src="appUrl+'/'+image.image_path" 
                                                :alt="product.title+' - '+index" 
                                                class="img-fluid"> 
                                        </a>
                                    </div>
                                </div>
                            </article>
                        </aside>
                        <aside class="col-sm-7">
                            <article class="card-body p-2">
                                <h3 class="title my-3">{{ product.title }}</h3>
                                <p>
                                    <strong>Category:</strong> &nbsp;
                                    <a href="">{{ product.category.name }}</a>
                                </p>
                                <dl class="param param-feature">
                                    <dt>SKU : <span class="dt-text"> {{ product.sku }}</span></dt>
                                </dl>
                                <dl class="param param-feature">
                                    <dt>Brand :<span class="dt-text"> {{ product.brand.name }}</span></dt>
                                </dl>
                                <dl class="param param-feature">
                                    <dt>Minimum Order Quantity :<span class="dt-text"> {{ product.min_quantity }}</span></dt>
                                </dl>
                                <hr>
                                <p>
                                    <strong>Available In Stock :</strong> 
                                    <span class="stock-items">999 Items</span>
                                </p>
                                <p class="price-detail-wrap"> 
                                    <span class="price h3 strike"
                                        v-if="product.offer_price"> 
                                        <span class="currency">
                                            <i class="fas fa-rupee-sign"></i>
                                        </span>
                                        <span class="num">{{product.mrp}}</span>
                                    </span>
                                    <span class="price h3"
                                        v-else> 
                                        <span class="currency">
                                            <i class="fas fa-rupee-sign"></i>
                                        </span>
                                        <span class="num">{{product.mrp}}</span>
                                    </span>
                                    <span class="price h3"
                                        v-if="product.offer_price"> 
                                        <span class="currency">
                                            <i class="fas fa-rupee-sign"></i>
                                        </span>
                                        <span class="num">{{product.offer_price}}</span>
                                    </span>
                                    <span class="tax-included">Tax excluded</span>
                                </p>
                                <div class="row mt-4">
                                    <div class="col-sm-4">
                                        <dl class="param param-inline">
                                            <dd>
                                                <b-form-spinbutton id="product-quantity"
                                                    class="text-center"
                                                    size="lg" 
                                                    v-model="quantity"
                                                    min="0"
                                                    :max="product.min_quantity * 10"
                                                    :step="product.min_quantity"
                                                    @change="addToCart(product.id)"
                                                    inline></b-form-spinbutton>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                                <div>
                                    <span class="offer-in-stock">In stock</span>
                                </div>
                            </article>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
        <section class="description-bg" 
            v-if="productId > 0">
            <div class="container">
                <div class="nav-tabs-bg">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="product-offers-tab" 
                                data-toggle="tab" 
                                href="#offers" 
                                role="tab" 
                                aria-controls="product-offers" 
                                aria-selected="true"
                                v-if="product.level_1_price !== null && product.level_2_price !== null && product.level_3_price !== null">
                                Offers
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="product-description-tab" 
                                data-toggle="tab" 
                                href="#description" 
                                role="tab" 
                                aria-controls="product-description" 
                                aria-selected="true"
                                v-if="product.description !== null">
                                Description
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="product-policy-tab" 
                                data-toggle="tab" 
                                href="#policy" 
                                role="tab" 
                                aria-controls="product-policy" 
                                aria-selected="true"
                                v-if="product.policy !== null">
                                {{ product.policy.policy.title }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="brand-description-tab" 
                                data-toggle="tab" 
                                href="#about-brand" 
                                role="tab" 
                                aria-controls="profile" 
                                aria-selected="false"
                                v-if="product.brand.description !== null">
                                About brands
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content mt-3" id="myTabContent">
                        <div class="tab-pane fade show active" 
                            id="offers" 
                            role="tabpanel" 
                            aria-labelledby="product-offers-tab"
                            v-if="product.level_1_price !== null && product.level_2_price !== null && product.level_3_price !== null">
                            <div class="row">
                                <div class="col-md-4">
                                    <b-card :title="'More than '+ product.level_1_quantity">
                                        <b-card-text>
                                            <span class="price">
                                                <i class="fas fa-rupee-sign"></i>
                                                {{product.level_1_price}} per unit
                                            </span>
                                        </b-card-text>
                                    </b-card>
                                </div>
                                <div class="col-md-4">
                                    <b-card :title="'More than '+ product.level_2_quantity">
                                        <b-card-text>
                                            <span class="price">
                                                <i class="fas fa-rupee-sign"></i>
                                                {{product.level_2_price}} per unit
                                            </span>
                                        </b-card-text>
                                    </b-card>
                                </div>
                                <div class="col-md-4">
                                    <b-card :title="'More than '+ product.level_3_quantity">
                                        <b-card-text>
                                            <span class="price">
                                                <i class="fas fa-rupee-sign"></i>
                                                {{product.level_3_price}} per unit
                                            </span>
                                        </b-card-text>
                                    </b-card>
                                </div>
                            </div>  
                        </div>
                        <div class="tab-pane fade" 
                            id="description" 
                            role="tabpanel" 
                            aria-labelledby="product-description-tab"
                            v-if="product.description !== null"
                            v-html="product.description"></div>
                        <div class="tab-pane fade" 
                            id="policy" 
                            role="tabpanel" 
                            aria-labelledby="product-policy-tab"
                            v-if="product.policy !== null"
                            v-html="product.policy.policy.description"></div>
                        <div class="tab-pane fade" 
                            id="about-brands" 
                            role="tabpanel" 
                            aria-labelledby="brand-description-tab"
                            v-if="product.brand.description !== null"
                            v-html="product.brand.description"></div>
                    </div>
                </div>
            </div>
        </section>
        <notifications group="cart" />
    </div>
</template>
<script>
    export default {
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                productId: 0,
                quantity: 0,
                product: [],
                mainImage: null,
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
            };
        },
        mounted() {
            this.getProduct();
        },
        methods: {
            getProduct() {
                var that = this;
                axios.get('api/get-products/' + this.id)
                .then(function(response) {
                    that.productId = that.id;
                    that.product = response.data.product;
                    that.quantity = response.data.product.cart_quantity;
                    if (response.data.product.images[0]) {
                        that.mainImage = response.data.product.images[0].image_path;
                    } else {
                        that.mainImage = '/images/default-image.jpg';
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            addToCart(id) {
                var that = this;
                axios.post('api/add-to-cart', {
                    id: id,
                    quantity: that.quantity,
                })
                .then(function(response) {
                    if (response.data.success) {
                        that.$notify({
                            group: 'cart',
                            title: 'Success',
                            type: 'success',
                            text: response.data.message
                        });
                    } else {
                        that.$notify({
                            group: 'cart',
                            title: 'Error',
                            type: 'error',
                            text: response.data.message
                        });
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            updateMainImage(path) {
                this.mainImage = path;
            }
        }
    };
</script>
